import { Table, Text } from "@mantine/core";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";

export function HeldEmailRecipientCells({
  email,
}: {
  email: HeldEmailListItem;
}) {
  return (
    <>
      <Table.Td>
        <Text size="sm">{email.recipient}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{email.caseNumber ?? "—"}</Text>
      </Table.Td>
    </>
  );
}
